export default __webpack_public_path__ + "static/media/The Art of Rapid Steps.c2a0f91c.png";